import React, { FC } from "react";
import { useHistory } from "react-router-dom";
import { PageNotFound } from "../../templates/PageNotFound";

const PageNotFoundPage: FC = () => {
  let history = useHistory();
  const title = "Oops!";
  const subTitle = "Page Not Found";
  const text =
    "We’re sorry, the page you requested could not be found. Please go back to your previous page.";
  const buttonText = "Go Back";
  const routeChange = () => {
    history.goBack();
  };

  return (
    <PageNotFound
      title={title}
      subTitle={subTitle}
      onClick={routeChange}
      buttonText={buttonText}
      text={text}
    />
  );
};

export default PageNotFoundPage;
